module.exports = __webpack_public_path__ + "img/ro.eeb706a7.svg";